import MdEntity from "core/metamodel/mdEntity";
import {GridLocation} from "core/grid/domain/grid";
import {stringify} from "core/common/utils/jsonUtils";
export function writeCookie(name: string, value: string, days: number) {
  let expires;

  if (days) {
    const date: Date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  else {
    expires = "";
  }

  document.cookie = name + "=" + value + expires + "; path=/";
}


export function getCookie(cname: string) : string {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i=0; i<ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }
  return "";
}


function storagePrefix(objectType: string, lang: string, objektId: string) {
  return  objectType + "_" + lang + "_" + window.TENANT_ID + "_" + objektId;
}


export function setItemToLocalStorage<T>(objectType: string, lang: string, objektId: string, objekt: T): void {
  window.localStorage.setItem(storagePrefix(objectType, lang, objektId), stringify(objekt));
}

export function getItemFromLocalStorage(objectType: string, lang: string, objektId: string): string {
  return <any> window.localStorage.getItem(storagePrefix(objectType, lang, objektId));
}


export function removeItemFromLocalStorage(objectType: string, lang: string, objektId: string): void {
  window.localStorage.removeItem(storagePrefix(objectType, lang, objektId));
}



// WEBPACK FOOTER //
// ./src/core/common/utils/storage.ts